import React from "react";
import { Facebook, Instagram, Linkedin, Youtube, X } from "lucide-react";
import fb from "../../assets/image/fb.png";
import xicon from "../../assets/image/x-icon.png";
import linkedin from "../../assets/image/in.png";
import instagram from "../../assets/image/insta.png";
import youtube from "../../assets/image/ytb.png";
import googleplay from "../../assets/image/google-play.png";
import appstore from "../../assets/image/app-stor.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row row-cols-2 row-cols-sm-2 row-cols-md-5">
        <div className="col">
        <div className="footer-column">
          <h4 className="footer-heading">Patients</h4>
          <ul className="footer-list">
            <li>Book a Test</li>
            <li>Upload Prescription</li>
            <li>Download Report</li>
            <li>Health Packages</li>
            <li>Lab Locator</li>
          </ul>
        </div>
        </div>
      

        <div className="col">
        <div className="footer-column">
          <h4 className="footer-heading">Partner with us</h4>
          <ul className="footer-list">
            <li>Franchise Opportunities</li>
            <li>Corporate Wellness</li>
            <li>Hospital Lab Management</li>
            <li>Organise Camps</li>
          </ul>
        </div>
        </div>

    
        <div className="col">
        <div className="footer-column">
          <h4 className="footer-heading">Doctors</h4>
          <ul className="footer-list">
            <li>National Reference Lab</li>
            <li>Research and Development</li>
            <li>Download Forms</li>
            <li>Scientific Literature</li>
          </ul>
        </div>
        </div>

  
        <div className="col">
        <div className="footer-column">
          <h4 className="footer-heading">Company</h4>
          <ul className="footer-list">
            <li>About Us</li>
            <li>Mission & Vision</li>
            <li>Board of Directors</li>
            <li>Management</li>
            <li>Career</li>
            <li>Newsletter</li>
            <li>PR Media</li>
            <li>Disclosures</li>
          </ul>
        </div>
        </div>

     
        <div className="col">
        <div className="footer-column">
          <h4 className="footer-heading">Contact Us</h4>
          <ul className="footer-list">
            <li>Get in touch</li>
            <li>FAQ</li>
            <li>Sitemap</li>
          </ul>
          <h4 className="footer-heading">Download App</h4>
          <div className="app-download">
            <a
              href="https://apps.apple.com/in/app/pathkind-labs/id6472930066"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={appstore} alt="App Store" className="app-img" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.pathkind.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={googleplay} alt="Play Store" className="app-img" />
            </a>
          </div>
        </div>
        </div>

     
        </div>
        {/* <div className="qr-code">
          <div className="qr-container">
            <p className="qr-text">Download Our App</p>
            <img src="/qr-code.png" alt="QR Code" className="qr-img" />
          </div>
        </div> */}
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <div className="col-md-12 col-lg-12">
            <div className="row">
              <div className="col-12 col-md-9">
                <div className="footer-bottom-left">
                  <strong>Get in Touch</strong> <br />
                  <a
                    href="https://www.pathkindlabs.com/terms-use"
                    class=""
                    title="Terms of Use"
                  >
                    Terms of Use
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://www.pathkindlabs.com/disclaimer"
                    class=""
                    title="Disclaimer"
                  >
                    Disclaimer
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://www.pathkindlabs.com/privacy-policy"
                    class=""
                    title="Privacy Policy"
                  >
                    Privacy Policy
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://www.pathkindlabs.com/blog"
                    class=""
                    title="Blogs"
                  >
                    Blogs
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://www.pathkindlabs.com/covid-19-video"
                    class=""
                    title="video"
                  >
                    Video
                  </a>{" "}
                  |{" "}
                  <a
                    class="new-tab"
                    href="https://edos.pathkindlabs.com/"
                    rel="nofollow"
                    title="EDOS"
                    target="_blank"
                  >
                    EDOS
                  </a>{" "}
                  <br />
                  Call Us: <a href="tel:7500075111">75000 75111</a> | Mail Us:
                  <a href="mailto:care@pathkindlabs.com">
                    care@pathkindlabs.com
                  </a>{" "}
                  |{" "}
                  <a href="https://www.pathkindlabs.com/radiology">
                    Radiology Test Available only in Varanasi, Kolkata &amp;
                    Gurgaon
                  </a>{" "}
                  <br />© 2025 Pathkind Diagnostics Pvt. Ltd. All Rights
                  Reserved | Unsubscribe
                </div>
              </div>
              <div className="col-12 col-md-3">
                <div className="footer-social">
                  <div className="footer-follow">Follow us</div>
                  <a
                    href="https://www.facebook.com/PathkindLabs/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={fb} alt="Facebook" className="social-icon pr-3" />
                  </a>
                  <a
                    href="https://twitter.com/pathkindlabs"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={xicon} alt="X" className="social-icon pr-3" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/pathkind-diagnostics-pvt-ltd"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={linkedin}
                      alt="LinkedIn"
                      className="social-icon pr-3"
                    />
                  </a>
                  <a
                    href="https://www.instagram.com/pathkind/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={instagram}
                      alt="Instagram"
                      className="social-icon pr-3"
                    />
                  </a>
                  <a
                    href="https://www.youtube.com/@pathkind-labs"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={youtube} alt="YouTube" className="social-icon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
